import { useTreasuryAuthStore } from '../store/treasury-auth'
interface WidgetInfo {
  treasuryCtrl: boolean
}
/**
 * 返回金库认证头
 * @param treasuryControl 是否需要金库认证
 * @returns 判断结果
 */
export const getTreasuryHeader = (widgetInfo: WidgetInfo) => {
  if (widgetInfo) {
    const { treasuryCtrl } = widgetInfo
    const treasuryAuthStore = useTreasuryAuthStore()
    if (treasuryAuthStore.jkConfigName !== '' && treasuryCtrl) {
      return {
        treasury: true
      }
    }
  }

  return {}
}
